
import UserInterface from "@/interfaces/User";
import UserService from "@/services/UserService";
import { cnpj as CNPJ, cpf as CPF } from "cpf-cnpj-validator";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import CadastroEnderecoCard from "./CadastroEnderecoCard.vue";

const Notifications = namespace("Notifications");

@Component({
  components: {
    CadastroEnderecoCard,
  },
})
export default class CadastroUserComponent extends Vue {
  @Notifications.Action
  showInfoMessage!: (message: string) => Promise<any>;

  @Notifications.Action
  showErrorMessage!: (message: string) => Promise<any>;

  dialogEndereco = false;
  endereco_required = false;

  newUser = {} as UserInterface;
  regras = {
    vazio: (v: string) => {
      return !!v || "Campo obrigatório";
    },
    minChars: (v: string) => {
      return (v && v.length >= 8) || "Mínimo de 8 caracteres";
    },
    cpfCnpj: (v: string) => {
      const reg = /[^0-9]/g;
      const parsed = v?.replace(reg, "") || "";

      return (
        (v &&
          ((parsed.length === 11 && CPF.isValid(parsed)) ||
            (parsed.length === 14 && CNPJ.isValid(parsed)))) ||
        "CPF / CNPJ inválido"
      );
    },
    minCharsCnpj: (v: string) => {
      return (v && v.length == 18 && CNPJ.isValid(v)) || "CNPJ inválido";
    }, //18 por causa da formatação
    email: (v: string) => {
      return /.+@.+\..+/.test(v) || "Insira um e-mail válido";
    },
    passwordMatch: (v: string) => {
      return (v && v === this.newUser.password) || "Senhas não coincidem";
    },
  };

  get usernameInput() {
    return this.newUser.username;
  }

  set usernameInput(value) {
    this.newUser.username = value?.replaceAll(" ", "");
    (this.$refs.usuario as any).lazyValue = this.newUser.username;
  }

  get cpfCnpjMask() {
    const reg = /[^0-9]/g;
    const parsed = this.newUser.clientCnpj?.replace(reg, "") || "";

    if (parsed.length <= 11) {
      return "###.###.###-##";
    }
    return "##.###.###/####-##";
  }

  isFormValid = false;
  pwdBtn = {
    reg: false,
    regVerif: false,
  };

  isLoading = false;

  validateCadastro() {
    // validate endereco
    if (!this.newUser?.endereco){
      this.endereco_required = true;
      return;
    } else {
      this.endereco_required = false;
    }
    if (
      (
        this.$refs.formCadastro as Vue & { validate: () => boolean }
      ).validate() &&
      this.isFormValid
    ) {
      this.isLoading = true;
      UserService.register(this.newUser)
        .then(
          (data) => {
            this.showInfoMessage(
              "Cadastro efetuado com sucesso. Aguardando aprovação do administrador."
            );
            this.voltar({});
          },
          (error) => {
            const message = error.response.data || error.message || error;
            this.showErrorMessage(message);
          }
        )
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  voltar(evento: any) {
    if (!evento) return;
    this.$emit("onVoltarPrincipal");
  }

  onFechar() {
    this.$emit("fecharDialog");
  }
}
